import { AppShell, type ShellNavigationEntry, type ShellNavigationItem } from '@/platform/shell/AppShell'
import { featureManifests } from '@/app/navigation/manifests'
import { ttsNavigationItems } from '@/features/tts/manifest'

function createNavigation(): ShellNavigationEntry[] {
  const entries: ShellNavigationEntry[] = []
  const groups = new Map<string, Extract<ShellNavigationEntry, { kind: 'group' }>>()

  for (const feature of featureManifests) {
    if (feature.hideFromNavigation) continue
    if (feature.id === 'tts') {
      entries.push({
        kind: 'group',
        id: 'tts',
        label: 'Dịch vụ TTS',
        items: ttsNavigationItems.map(({ id, path, label }) => ({ id, path, label })),
      })
      continue
    }

    const item: ShellNavigationItem = {
      id: feature.id,
      path: feature.navPath,
      label: feature.label,
    }

    if (!feature.navigationGroup) {
      entries.push(item)
      continue
    }

    let group = groups.get(feature.navigationGroup.id)
    if (!group) {
      group = { kind: 'group', id: feature.navigationGroup.id, label: feature.navigationGroup.label, items: [] }
      groups.set(group.id, group)
      entries.push(group)
    }
    group.items.push(item)
  }

  return entries
}

const navigation = createNavigation()

export function AppShellLayout() {
  return <AppShell homePath="/english-knowledge/vocabularies/catalogs" navigation={navigation} />
}
